<template>
  <div class="submit">
    <div class="header container">
      <view-nav></view-nav>
    </div>
    <div class="submit-box">
      <div class="footer-fower flower1"></div>
      <div class="footer-fower flower2"></div>
      <div class="footer-fower flower3"></div>
      <div class="footer-fower flower4"></div>
      <div class="title-content wrap">
        <h1>申报详情</h1>
        <div class="text">
          <p>为贯彻落实党的十九大精神和中办国办《关于加强文物保护利用改革的若干意见》《关于实施革命文物保护利用工程（2018-2022年）的意见》，促进博物馆推出陈列展览精品，满足人民群众美好文化生活的需要，中国博物馆协会、中国文物报社将组织开展第十七届（2019年度）全国博物馆十大陈列展览精品（以下简称“十大精品”）推介活动。</p>
        </div>
        <!-- 目前该申报按钮置灰不可点击 -->
        <div class="btn-box box" @click.stop="util.toDeclare()">
          <p>立即申报</p>
        </div>
      </div>
    </div>
    <div class="submit-container">
      <!--时间线-->
      <ul class="time-line">
        <li class="date">
          <h3>3月20日</h3>
          <h4>2020</h4>
          <div>
            <p>网上填报</p>
          </div>
        </li>
        <li class="date">
          <h3>3月30日</h3>
          <h4>2020</h4>
          <div>
            <p>初评期</p>
          </div>
        </li>
        <li class="date">
          <h3>4月10日</h3>
          <h4>2020</h4>
          <div>
            <p>终评期</p>
          </div>
        </li>
        <li class="date">
          <h3>5月18日</h3>
          <h4>2020</h4>
          <div>
            <p>获奖公示/颁奖</p>
          </div>
        </li>
        <li class="date">
        </li>
      </ul>
      <!--标题-->
      <h2 class="title">活动内容</h2>
      <!--内容-->
      <div class="text-box">
        <p class="text-title">一、活动内容</p>
        <p class="text-content">组织开展第十七届（2019年度）全国博物馆“十大精品”遴选、宣传推介和经验交流。</p>
        <p class="text-title">二、活动组织</p>
        <p class="text-content">第十七届（2019年度）全国博物馆“十大精品”推介活动由中国博物馆协会和中国文物报社主办，主办单位联合设立推介活动办公室负责具体工作，推介活动办公室设在中国文物报社。</p>
        <p class="text-title">三、推介要求</p>
        <p class="text-content">（一）在文物部门注册登记的博物馆或相关文博机构自主策划、举办的原创性展览，并应符合下列条件：</p>
        <p class="text-content">1、2019年对社会正式开放的常设展览。</p>
        <p class="text-content">2、延续开放至2019年12月31日且未参加过往届全国博物馆十大陈列展览精品推介的常设展览。</p>
        <p class="text-content">3、2019年举办的连续展期不少于3个月（90天）的临时展览；配合国家重大活动或出于对脆弱易损文物展品的保护需要而控制展期的临时展览，连续展期不少于30天。</p>
        <p class="text-content">4、展览项目应在国家文物局博物馆网上展览平台进行展示。</p>
        <p class="text-content">5、在国际及港澳台文化交流中产生良好影响，并符合上述条件的出入境展览（连续展期不少于30天），可参加国际及港澳台合作奖推介。</p>
        <p class="text-content">（二）一个陈列展览只能参加一届次推介；作出重大调整的常设展览可在改陈后参评，申报时应对改陈情况作出说明，并报送改陈前后的展览大纲。</p>
        <p class="text-content">（三）每个申报单位限报一个境内陈列展览、一个出入境展览。</p>
        <p class="text-content">（四）参加推介活动的博物馆须在近两年内未发生过文物、标本等藏品被盗、损毁等重大安全事故。
        </p>
        <p class="text-title">四、推介项目设置</p>
        <p class="text-content">本届推介活动原则上设精品奖10个，优胜奖10个，国际及港澳台合作奖若干。</p>
        <p class="text-content">本届推介活动常设展览（包括基本陈列和专题陈列）和临时展览实行分类评价。</p>
        <p class="text-title">五、入围标准</p>
        <p class="text-content">（一）坚持正确的政治方向和价值导向,对存在意识形态方面问题的，坚持一票否决。</p>
        <p class="text-content">（二）展览组织有序、流程合理，策展人、内容设计与形式设计主创人员及团队、展览实施机构各司其职、角色清晰、分工明确。</p>
        <p class="text-content">（三）展览选题新颖、个性鲜明，能够体现时代精神，贴近实际、贴近生活、贴近群众，具有较强的思想性、知识性和原创性。</p>
        <p class="text-content">（四）展览内容能够体现最新研究成果，具有较高的学术、文化含量；展品组织科学合理、层次清晰、重点突出，信息传达准确、有效。</p>
        <p class="text-content">（五）形式设计有新的探索或突破，达到形式设计与内容设计的和谐统一。</p>
        <p class="text-content">（六）展览制作精良，工艺精细，科技含量高，新技术、新材料运用得当，具有良好的展示效果。</p>
        <p class="text-content">（七）展厅内具有达标的安全技术防范设备和防止展品遭受自然损害的展出设施和环境。</p>
        <p class="text-content">（八）利用大众媒体、新媒体及其他手段，及时、广泛、有效地进行展览宣传；相关文化产品设计精致、特色鲜明，能够满足不同观众的需求。</p>
        <p class="text-content">（九）陈列展览的讲解咨询、公众服务周到细致。</p>
        <p class="text-content">（十）围绕和配合展览组织开展讲座、研讨会、出版相关研究书籍等一系列延伸教育活动。</p>
        <p class="text-content">（十一）陈列展览深受观众欢迎，社会反响强烈。</p>
        <p class="text-content">（十二）网上展览、新媒体展示效果良好。</p>
        <p class="text-title">六、材料报送</p>
        <p class="text-content">（一）由各省（自治区、直辖市）文物行政部门择优向推介活动办公室推荐，每省推荐的境内陈列展览不能多于6个、出入境展览不能多于2个。鼓励行业博物馆和非国有博物馆参加，每省推荐的陈列展览中，至少应包括1个文物系统以外博物馆的陈列展览。</p>
        <p class="text-content">（二）中央部委及其有关单位所属博物馆、军队系统所属博物馆及国家文物局直属单位参加推介的陈列展览，可直接报送推介活动办公室，每单位限报1个境内展览、1个出入境展览。</p>
        <p class="text-content">（三）申报单位应认真填报《第十七届（2019年度）全国博物馆十大陈列展览精品推介活动申报书》。《全国博物馆十大陈列展览精品推介办法》《申报书》可登录中国博物馆协会网站（<a href="http://www.chinamuseum.org.cn" target="_blank">http://www.chinamuseum.org.cn</a>）或文博在线网站（<a href="http://www.wenbozaixian.com/" target="_blank">http://www.wenbozaixian.com/</a>）博物馆展览网上申报评审系统（<a href="https://museumcloud.vizen.cn/" target="_blank">https://museumcloud.vizen.cn/</a>）下载。</p>
        <p class="text-content"> 申报书应单独成册，A4纸打印、左侧装订，一式2份；附件材料应与申报书统一规格附于申报书后，一式2份；申报书及附件材料均应以U盘形式提交电子版，并保证电子版与纸质版数据完全一致。</p>
        <p class="text-content">（四）为提高评审工作效率，加大展览推介力度，本年度增加在线申报和网上展示环节。请于3月20日起至3月30日登陆国家文物局政府网站“博物馆网上展览平台·第十七届（2019年度）全国博物馆十大陈列展览精品申报专区”，根据提示填写网上申报书及相关附件材料（网上填报内容需与纸质版数据完全一致）。</p>
        <p class="text-content">（五）推荐项目及申报材料（纸质和U盘）请于2020年3月20日前报送至推介活动办公室。</p>
      </div>
      <a class="download-btn" href="/temp/申报材料.zip" download="">申报材料下载</a>
      <!-- 虚线 -->
      <div class="line"></div>
      <div class="contact">
        <div class="info">
          <p>联系人：李文昌 010—84079511，13651221995</p>
          <p style="text-indent: 4em">何薇 18810817088</p>
          <p>技术支持：刘宇凡  17611246922</p>
          <p style="text-indent: 5em">钱炳彰 13522809021</p>
          <p>材料报送地址：北京市东城区东直门内北小街2号楼中国文物报社总编室</p>
          <p>邮政编码：100007</p>
        </div>
        <div class="data">
          <p>中国博物馆协会    中国文物报社</p>
          <p>2020年2月27日</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'About',
  components: {
  },
  data () {
    return {
    }
  },
  created () {

  },
  mounted () {
    this.util.addMtah5ClickStat('submit')
  },
  methods: {}
}
</script>
<style lang="scss">
  .submit {
    width: 100%;
    min-width: 1200px;
    .wrap { width: 1200px; margin: 0 auto;}
    .container{
      position: relative;
      width: 100%;
      min-width: 1200px;
      overflow: hidden;
    }
    .submit-box {
      height: 430px;
      position: relative;
      background-image: linear-gradient(180deg, #FF4A21 0%, #AA0907 100%);
      text-align: center;
      overflow: hidden;
      .footer-fower{
        width: 394px;
        height: 394px;
        background: url("../assets/images/footer-flower.png") no-repeat 0 0;
        background-size: 394px 394px;
        &.flower1{
          position: absolute;
          left: -154px;
          top: -220px;
        }
        &.flower2{
          position: absolute;
          left: 28px;
          top: 94px;
        }
        &.flower3{
          position: absolute;
          right: 47px;
          top: -226px;
        }
        &.flower4{
          position: absolute;
          right: -128px;
          top: 89px;
        }
      }
      .title-content{
        height: 430px;
        position: relative;
         .btn-box{
          position: absolute;
          left: 50%;
          bottom: 40px;
          display: inline-block;
          padding: 12px 32px;
          box-shadow: 0 2px 4px 0 rgba(0,0,0,0.10);
          border-radius: 25px;
          text-align: center;
          transform: translateX(-50%);
          &:hover{
            // background: #c8c9cc;
          }
          p {
            font-size: 22px;
            color: #561014;
            letter-spacing: 2px;
            line-height: 26px;
            font-weight: bold;
          }
        }
      }
      h1 {
        padding: 62px 0 40px 0;
        font-size: 50px;
        color: #FFFFFF;
        letter-spacing: 3.12px;
        line-height: 50px;
      }
      .text {
        width: 644px;
        height: 160px;
        margin: 0 auto;
        p {
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 40px;
          text-align:justify;
          text-indent: 2em;
        }
      }
    }
    .submit-container {
      margin: 0 auto;
      width: 922px;
      .time-line{
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 164px;
        .date{
          width: 140px;
          height: 52px;
          margin-right: 110px;
          position: relative;
          &:nth-last-of-type(1){
            margin-right: 0;
          }
        }
        h3{
          width: 100%;
          font-size: 24px;
          color: #000000;
          letter-spacing: 0;
          line-height: 24px;
          text-align: center;
          font-weight: bold;
        }
        h4{
          width: 100%;
          font-size: 18px;
          color: #000000;
          letter-spacing: 0;
          line-height: 18px;
          text-align: center;
          margin-top: 10px;
          font-weight: bold;
        }
        div{
          width: 110px;
          height: 22px;
          background: url("../assets/images/date-line.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          right: -110px;
          top: 0;
          p{
            font-weight: normal;
            width: 200px;
            font-size: 24px;
            color: #000000;
            letter-spacing: 0;
            line-height: 24px;
            position: absolute;
            left: 50%;
            top: -64px;
            margin-left: -100px;
            text-align: center;
          }
        }
      }
      .title{
        width: 402px;
        font-size: 24px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        font-weight: bold;
        margin: 100px auto 65px;
        line-height: 33px;
        position: relative;
        &::after{
          content: ' ';
          width: 402px;
          height: 16px;
          background: url("../assets/images/title-line.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: 0;
          bottom: -20px;
        }
      }
      .text-box{
        width: 922px;
        margin: 80px auto 50px;

        .text-title{
          text-align:justify;
          font-size: 16px;
          color: #000000;
          letter-spacing: 0;
          line-height: 40px;
          font-weight: bold;
          .padding {
            margin: 20px 0 20px 0;
          }
        }
        .text-content{
          text-indent: 2em;
          text-align:justify;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          line-height: 40px;
          a{
            color: #0000ee;
          }
        }
      }
      .download-btn{
        display: block;
        width: 200px;
        height: 50px;
        cursor: pointer;
        background: linear-gradient(180deg, #FF4A21 0%, #AA0907 100%);
        border-radius: 25px;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 50px;
        text-align: center;
      }
      .line {
        height: 80px;
        width: 922px;
        border-bottom: 1px dashed #8E1212;
      }
      .contact {
        padding: 30px 0 214px 0;
        font-size: 16px;
        color: #000000;
        letter-spacing: 0;
        line-height: 40px;
        .info {
          margin-bottom: 100px;
        }
        .data {
          text-align: right;
        }
      }
    }
  }
</style>
